import React, { ReactElement } from 'react';
import { default as MSwitch } from '@material-ui/core/Switch';

import { makeStyles } from '@material-ui/core';

interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles({
  root: {
    width: 75,
  },
  track: {
    backgroundColor: 'var(--locationFilterToogleChecked)',
    opacity: '1 !important',
    height: 26,
    borderRadius: 50,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '45%',

      width: 16,
      height: 16,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        '#013b4a'
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 18,
    },

    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        '#013b4a'
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 15,
    },
  },
  thumb: {
    boxShadow: 'none',
    backgroundColor: 'var(--locationBar)',
    width: 18,
    height: 18,
    marginTop: 7,
    marginLeft: 10,
  },
  trackUnChecked: {
    backgroundColor: 'var(--locationFilterToogleUnChecked)',
  },
});

export default function Switch({ checked, defaultChecked, onChange }: SwitchProps): ReactElement {
  const classes = useStyles();

  return (
    <MSwitch
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={onChange}
      color="default"
      classes={{
        track: `${classes.track} ${checked ? '' : classes.trackUnChecked}`,
        thumb: classes.thumb,
        root: classes.root,
      }}
    />
  );
}
